export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16 8A8 8 0 110 8a8 8 0 0116 0zM8 5a.995.995 0 00-.75.339 1 1 0 11-1.5-1.324A3 3 0 119 8.83V9a1 1 0 01-2 0V8c0-.552.448-1 1-1a1 1 0 000-2zm0 8a1 1 0 100-2 1 1 0 000 2z\" fill=\"#ff00cb\"/>",
  "attrs": {
    "viewBox": "0 0 16 16",
    "width": "16",
    "height": "16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};